import { isString } from './isString';
/* eslint-disable */
export const toLowerCaseString = (input) => {
  if (isString(input)) {
    return input.toLowerCase();
  }
  return input;
};
